import { createFileRoute } from '@tanstack/react-router';

import { ReportingWaf } from 'component/partial/Reporting/ReportingWaf';

export const Route = createFileRoute('/n/_auth/sites/$siteId/_details/reporting/waf')({
  component: ReportingWafRoute,
});

function ReportingWafRoute() {
  return <ReportingWaf />;
}
